export default "__VITE_ASSET__ltXfZeSU__"